"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

var styles = {
  impactLogin: {
    color: '#fff',
    backgroundColor: '#002960',
    fontFamily: 'Open Sans,sans-serif',
    lineHeight: 1.4,
    letterSpacing: 'normal',
    fontSize: '14px',
    boxSizing: 'border-box',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh'
  },
  loginPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  },
  login: {
    width: '604px',
    height: '572px',
    minWidth: '550px',
    minHeight: '550px'
  },
  form: {
    boxSizing: 'border-box',
    position: 'relative',
    padding: '7rem',
    width: '100%',
    height: '100%',
    backgroundImage: 'linear-gradient(45deg,#00548e 3.85%,#002960 0,#002960 50%,#00548e 0,#00548e 53.85%,#002960 0,#002960)',
    backgroundSize: '18.38px 18.38px'
  },
  corner: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0 47px 47px 0',
    borderColor: 'transparent #0093d3 transparent transparent',
    position: 'absolute',
    top: 0,
    right: 0
  }
};

var ImpactLogin = function ImpactLogin(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.impactLogin
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.loginPage
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.login
  }, /*#__PURE__*/_react.default.createElement("form", {
    style: styles.form,
    onSubmit: function onSubmit(ev) {
      return ev.preventDefault();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.corner
  }), children)))));
};

ImpactLogin.propTypes = {
  children: _propTypes.default.any
};

var _default = (0, _radium.default)(ImpactLogin);

exports.default = _default;